import React from 'react';

// Intercepta fetch para capturar X-Plan/X-Remaining y mostrarlos en una barrita discreta.
let subscribers = [];
function publish(state){ subscribers.forEach(fn=>{ try{ fn(state); } catch{} }); }

// Instalar hook solo una vez
if (typeof window !== 'undefined' && !window.__USAGE_FETCH_PATCHED__) {
  window.__USAGE_FETCH_PATCHED__ = true;
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await originalFetch(...args);
    try {
      const plan = res.headers.get('X-Plan');
      const remaining = res.headers.get('X-Remaining');
      if (plan || remaining) publish({ plan, remaining, ts: Date.now(), url: (args[0] && args[0].toString()) || '' });
    } catch {}
    return res;
  };
}

export default function CommandRoomUsage(){
  const [state, setState] = React.useState(null);
  React.useEffect(()=>{ const sub=(s)=> setState(s); subscribers.push(sub); return ()=>{ subscribers = subscribers.filter(x=>x!==sub); }; },[]);
  if (!state) return null;
  return (
    <div className="fixed bottom-3 right-3 z-50 text-xs px-3 py-2 rounded-lg bg-black/60 border border-gray-700 text-gray-200 shadow-lg">
      <div className="flex items-center gap-2">
        <span className="opacity-70">Plan:</span>
        <strong>{state.plan || '—'}</strong>
        <span className="ml-3 opacity-70">Restante:</span>
        <strong>{state.remaining || '—'}</strong>
      </div>
    </div>
  );
}
